import { render } from "./SharedPlaybooks.vue?vue&type=template&id=377a8540&scoped=true"
import script from "./SharedPlaybooks.vue?vue&type=script&lang=js"
export * from "./SharedPlaybooks.vue?vue&type=script&lang=js"

import "./SharedPlaybooks.vue?vue&type=style&index=0&id=377a8540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377a8540"]])

export default __exports__